import { useEffect } from 'react';
import type { AppProps } from 'next/app';
import axios from 'axios';
import { ThemeProvider } from 'styled-components';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import TagManager from 'react-gtm-module';
import Head from 'next/head';
import 'react-toastify/dist/ReactToastify.css';
import 'react-day-picker/lib/style.css';

import theme from '../theme';
import GlobalStyle from '../styled/GlobalStyle';
import '../styles/bootstrap.min.css';
import '../styles/override.css';
import { store, persistor } from '../redux/store';
import { useRouter } from 'next/router';
import * as gtag from '../utils/gtag';
import * as uetTage from '../utils/uetTag';
import * as fbqTage from '../utils/facebook_track';
import * as qpTage from '../utils/quoraPixel';
// import * as fiboTage from '../utils/fibotalk';
import { initGA, logPageView } from '../utils/analytics';
import { getLocation } from '@/utils/getLocation';

const MyApp = ({ Component, pageProps }: AppProps) => {
  const router = useRouter();
  useEffect(() => {
    TagManager.initialize({ gtmId: 'GTM-55QK4RN' });
    getLocation()
      .then(res => {
        const data = res;
      })
      .catch(() => {

      });
    initGA();
    logPageView(window.location.href);
  }, []);
  useEffect(() => {
    const handleRouteChange = (url: any) => {
      gtag.pageview(url);
      uetTage.pageLoad(url);
      fbqTage.facebookPixelTrack(url);
      qpTage.qouraPixelTrack(url);
      initGA();
      logPageView(url);
    };

    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router.events]);

  const getRootComponent = () => {
    return process.browser ? (
      <>
        <Provider store={store}>
          <GlobalStyle />
          <PersistGate loading={null} persistor={persistor}>
            <Component {...pageProps} />
          </PersistGate>
          <ToastContainer />
        </Provider>
      </>
    ) : (
      <Provider store={store}>
        <GlobalStyle />
        <Component {...pageProps} />
        <ToastContainer />
      </Provider>
    );
  };

  return (
    <>
      <Head>
        <title>EzyLegal</title>
      </Head>
      <ThemeProvider theme={theme}>{getRootComponent()}</ThemeProvider>
    </>
  );
};

export default MyApp;
